import asyncActionTypes from '../../actions/types';
import TicketStamping from '../../../api-wrapper/ui-models/billing/ticketStamping';

const initialState = {
  ticketStampingArray: [],
  error: {
    actionType: '',
    actionable: '',
    code: '',
    codeAction: null,
    errorExtraInfo: '',
    errorMsg: '',
    errorUrl: '',
    event: '',
    statusCode: 0,
    type: '',
  },
  errorStampingBilling: false,
  loadingStampingBilling: false,
};

const stampingBilling = ( state = initialState, action ) => {
  switch (action.type) {
    case asyncActionTypes.GET_STAMPING_BILLING.START:
      return {
        ...initialState,
        loadingStampingBilling: true,
      };
    case asyncActionTypes.GET_STAMPING_BILLING.SUCCESS:
      const ticketStampingArray = action?.payload.map((ticket) => new TicketStamping(ticket));
      return {
        ...state,
        ticketStampingArray: ticketStampingArray,
        pathPdf: null,
        loadingStampingBilling: false,
      };
    case asyncActionTypes.GET_STAMPING_BILLING.FAIL:
      return {
        ...initialState,
        error: {
          ...action?.error,
        },
        errorStampingBilling: true,
        loadingStampingBilling: false,
      };
    default:
      return state;
  }
};

export default stampingBilling;